import React from "react";
import "./dashboardCard.css";
// import Wallet from "../../images/wallet-icon.svg";
import { formatToCurrency } from "../../utilities/utilities";
import ProgressBar from "../progressbar/progressBar";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
export default function DashboardCard({ hasPayment, wallet, notHomePage }) {
    const navigate = useNavigate();
    const userDetails = useSelector((state) => state.userDetails);
    const getCurrentLoggedInUser = useSelector(
        (state) => state.getCurrentLoggedInUser
    );
    const handleApplyAndPayment = () => {
        if (!hasPayment) {
            navigate("/loans/bvn-identification");
        }
    };
    return (
        <div className="row">
            {notHomePage ? (
                ""
            ) : (
                <div
                    style={{
                        marginBottom: "42px",
                        fontSize: "32px",
                        fontWeight: 900,
                        lineHeight: "48px",
                        color: "black",
                    }}
                >
                    <span className="dashboardHome">Home</span>
                    <div className="dashboardTitle">
                        Hi,{" "}
                        <strong>
                            {userDetails?.first_name +
                                " " +
                                userDetails.last_name}
                            ,
                        </strong>
                    </div>
                </div>
            )}

            <div className="col-md-9">
                <div className="dashboard-card-main-cover">
                    <div className="row m-0 p-0">
                        <div className="col-xl-1 col-lg-2 card-wallet-logo-div">
                            <svg
                                width="50"
                                height="68"
                                viewBox="0 0 68 68"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M59.5002 31.6878V19.8332C59.5002 19.0817 59.2017 18.3611 58.6703 17.8297C58.1389 17.2983 57.4183 16.9998 56.6668 16.9998H11.3335C10.582 16.9998 9.86138 16.7013 9.33003 16.17C8.79867 15.6386 8.50016 14.918 8.50016 14.1665C8.50016 13.4151 8.79867 12.6944 9.33003 12.163C9.86138 11.6317 10.582 11.3332 11.3335 11.3332H56.6668C57.4183 11.3332 58.1389 11.0347 58.6703 10.5033C59.2017 9.97195 59.5002 9.25128 59.5002 8.49984C59.5002 7.74839 59.2017 7.02772 58.6703 6.49637C58.1389 5.96501 57.4183 5.6665 56.6668 5.6665H11.3335C9.07916 5.6665 6.91715 6.56204 5.32309 8.1561C3.72903 9.75016 2.8335 11.9122 2.8335 14.1665V53.8332C2.8335 56.0875 3.72903 58.2495 5.32309 59.8436C6.91715 61.4376 9.07916 62.3332 11.3335 62.3332H56.6668C57.4183 62.3332 58.1389 62.0347 58.6703 61.5033C59.2017 60.972 59.5002 60.2513 59.5002 59.4998V47.6452C61.1564 47.0682 62.592 45.9901 63.6078 44.5604C64.6237 43.1307 65.1695 41.4203 65.1695 39.6665C65.1695 37.9127 64.6237 36.2023 63.6078 34.7726C62.592 33.3429 61.1564 32.2648 59.5002 31.6878ZM53.8335 56.6665H11.3335C10.582 56.6665 9.86138 56.368 9.33003 55.8366C8.79867 55.3053 8.50016 54.5846 8.50016 53.8332V22.1452C9.40756 22.4807 10.3661 22.6571 11.3335 22.6665H53.8335V31.1665H45.3335C43.0792 31.1665 40.9171 32.062 39.3231 33.6561C37.729 35.2502 36.8335 37.4122 36.8335 39.6665C36.8335 41.9208 37.729 44.0829 39.3231 45.6769C40.9171 47.271 43.0792 48.1665 45.3335 48.1665H53.8335V56.6665ZM56.6668 42.4998H45.3335C44.582 42.4998 43.8614 42.2013 43.33 41.67C42.7987 41.1386 42.5002 40.418 42.5002 39.6665C42.5002 38.9151 42.7987 38.1944 43.33 37.663C43.8614 37.1317 44.582 36.8332 45.3335 36.8332H56.6668C57.4183 36.8332 58.1389 37.1317 58.6703 37.663C59.2017 38.1944 59.5002 38.9151 59.5002 39.6665C59.5002 40.418 59.2017 41.1386 58.6703 41.67C58.1389 42.2013 57.4183 42.4998 56.6668 42.4998Z"
                                    fill="#2BC155"
                                />
                            </svg>
                        </div>
                        <div className="col-lg-5  dashboard-balance-card">
                            <span className="balance-text">Balance</span>
                            {/* <br /> */}
                            {/* <span style={{ fontSize: "10px", color: "#A6ACBE" }}>
            Wallet ID: {wallet?.Wallet?.walletId}
          </span> */}
                            <br />

                            <span className="amount-span">
                                &#8358;
                                {wallet?.Wallet?.disbursedAmount
                                    ? formatToCurrency(wallet?.Wallet?.amount)
                                    : formatToCurrency(0)}
                            </span>
                            <br />
                            {hasPayment ? (
                                <span
                                    style={{
                                        paddingTop: "13px",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        color: "rgba(0, 0, 0, 0.32)",
                                    }}
                                >
                                    Apply for a card
                                </span>
                            ) : (
                                ""
                            )}
                        </div>
                        {/* <div
          className={
            hasPayment
              ? `col-lg-5 next-payment-div`
              : `col-lg-5 eligibility-div`
          }
        >
          {hasPayment ? (
            <div
              style={{
                textAlign: "left",
                fontSize: "14px",
                fontWeight: "500px",
                color: "rgba(0, 0, 0, 0.32)",
              }}
            >
              Next repayment
              <br />
              <span
                style={{
                  paddingTop: "4px",
                  fontSize: "16px",
                  fontWeight: "500px",
                  color: "black",
                }}
              >
                08/21
              </span>
            </div>
          ) : (
            " You currently have no loan, check if you qualify"
          )}
        </div> */}
                        {/* <div className="col-lg-3 button-div">
          <button
            className="apply-button btn btn-default"
            onClick={handleApplyAndPayment}
          >
            {hasPayment ? "Make Payment" : "Apply Now"}
          </button>
        </div> */}
                    </div>
                    <div style={{ paddingTop: "64px", paddingBottom: "75px" }}>
                        <ProgressBar />
                    </div>
                </div>
            </div>
            {getCurrentLoggedInUser?.user_status?.apply_for_loan === true ||
            getCurrentLoggedInUser?.user_status?.apply_for_loan ===
                undefined ? (
                <></>
            ) : (
                <div className="col-md-3 dashboard-apply-now-button">
                    <svg
                        width="260"
                        height="89"
                        viewBox="0 0 260 89"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/loans/select-loan")}
                    >
                        <rect
                            x="5"
                            width="255"
                            height="70"
                            rx="30"
                            fill="#47B638"
                        />
                        <g filter="url(#filter0_d_3_1513)">
                            <rect
                                x="20"
                                y="11"
                                width="48"
                                height="48"
                                rx="24"
                                fill="white"
                            />
                        </g>
                        <path
                            d="M41.552 24.592V32.458H33.876V36.106H41.552V43.972H45.58V36.106H53.256V32.458H45.58V24.592H41.552Z"
                            fill="#47B638"
                        />
                        <path
                            d="M101.88 42H104.28L99.3 28.08H96.66L91.68 42H94.06L95.06 39.16H100.88L101.88 42ZM100.24 37.3H95.7L97.98 30.84L100.24 37.3ZM108.725 32.6V30.98H106.445V47.24H108.725V40.4C109.445 41.26 110.745 42.18 112.565 42.18C115.465 42.18 117.745 39.84 117.745 36.44C117.745 33.04 115.465 30.8 112.565 30.8C110.765 30.8 109.425 31.68 108.725 32.6ZM115.425 36.44C115.425 38.82 113.785 40.2 112.065 40.2C110.365 40.2 108.725 38.86 108.725 36.48C108.725 34.12 110.365 32.78 112.065 32.78C113.785 32.78 115.425 34.06 115.425 36.44ZM122.28 32.6V30.98H120V47.24H122.28V40.4C123 41.26 124.3 42.18 126.12 42.18C129.02 42.18 131.3 39.84 131.3 36.44C131.3 33.04 129.02 30.8 126.12 30.8C124.32 30.8 122.98 31.68 122.28 32.6ZM128.98 36.44C128.98 38.82 127.34 40.2 125.62 40.2C123.92 40.2 122.28 38.86 122.28 36.48C122.28 34.12 123.92 32.78 125.62 32.78C127.34 32.78 128.98 34.06 128.98 36.44ZM133.555 42H135.835V27.2H133.555V42ZM143.168 39.38L140.068 30.98H137.528L141.868 41.82L139.628 47.18H141.988L148.748 30.98H146.388L143.168 39.38Z"
                            fill="white"
                        />
                        <defs>
                            <filter
                                id="filter0_d_3_1513"
                                x="0"
                                y="1"
                                width="88"
                                height="88"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                            >
                                <feFlood
                                    flood-opacity="0"
                                    result="BackgroundImageFix"
                                />
                                <feColorMatrix
                                    in="SourceAlpha"
                                    type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                    result="hardAlpha"
                                />
                                <feOffset dy="10" />
                                <feGaussianBlur stdDeviation="10" />
                                <feColorMatrix
                                    type="matrix"
                                    values="0 0 0 0 0.243137 0 0 0 0 0.286275 0 0 0 0 0.329412 0 0 0 0.35 0"
                                />
                                <feBlend
                                    mode="normal"
                                    in2="BackgroundImageFix"
                                    result="effect1_dropShadow_3_1513"
                                />
                                <feBlend
                                    mode="normal"
                                    in="SourceGraphic"
                                    in2="effect1_dropShadow_3_1513"
                                    result="shape"
                                />
                            </filter>
                        </defs>
                    </svg>
                    <div></div>
                </div>
            )}
        </div>
    );
}
